import {useEffect, useMemo} from 'react';

// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project import
import Profile from './Profile';
import XeroSubscriptions from "./XeroSubscriptions";

import { MenuOrientation } from '../../../../config';
import useConfig from '../../../../hooks/useConfig';
// import {getSubscriptions} from "../../../../store/reducer/xero_connection";

const HeaderContent = (props) => {
    const { i18n, menuOrientation } = useConfig();
    const xeroSubscription = useMemo(()=> <XeroSubscriptions handlerSetSubscriptionSelect={props.handlerSetSubscriptionSelect} getUsersList={props.getUsersList} getSubscriptions={props.getSubscriptions} handlerResetPayables={props.handlerResetPayables}/>, [i18n]);
    // const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
    const LogoutButton = props.LogoutButton


    return (
        <>
            <Box sx={{ width: '100%', ml: 1 }} />
            {xeroSubscription}
            <Profile LogoutButton={LogoutButton} />
            {/*{downLG && <Box sx={{ width: '100%', ml: 1 }} />}*/}
            {/*{!downLG && <Profile />}*/}
        </>
    )

};

export default HeaderContent;
